import { css } from '@emotion/react'

export const styles = {
  container: css`
    padding: 32px;
  `,
}
